<template>
  <div class="el-form-item item remind" :class="[viewMode ? 'view' : '']">
    <label for="time" class="el-form-item__label" :style="labelWidth ? `width: ${labelWidth}` : ''">
      {{ label }}{{ viewMode ? '：' : '' }}
    </label>
    <div class="el-form-item__content">
      <div class="content">
        <div class="left">
          提前
          <el-select v-if="!viewMode" v-model="value1" placeholder="请选择" filterable @change="change">
            <el-option v-for="(n, i) in options1" :key="n.label + i" :label="n.label" :value="n.value">
            </el-option>
          </el-select>
          <span v-if="viewMode">{{ value1 }}天</span>
          提醒
        </div>
        <div class="left">
          间隔
          <el-select v-if="!viewMode" v-model="value2" placeholder="请选择" filterable @change="change2">
            <el-option v-for="(n, i) in options2" :key="n.label + i" :label="n.label" :value="n.value">
            </el-option>
          </el-select>
          <span v-if="viewMode">{{ value2 }}天</span>
          提醒一次
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FormItemRemind",
  props: {
    config: Object,
    options1: Array,
    options2: Array,
    labelWidth: String,
    inputValue: [String, Array, Object, Number],
    inputValue2: [String, Array, Object, Number],
    viewMode: Boolean,
  },
  data() {
    return {
      label: this.config.label,
      value1: this.inputValue,
      value2: this.inputValue2,
    };
  },
  watch: {
    inputValue: {
      deep: true,
      handler(newVal) {
        // console.log(`input '${this.keyName}' value is '${newVal}'`);
        this.value1 = newVal;
      },
    },
    inputValue2: {
      deep: true,
      handler(newVal) {
        // console.log(`input '${this.keyName}' value is '${newVal}'`);
        this.value2 = newVal;
      },
    },
  },
  methods: {
    change(v) {
      this.$emit("onChange", {
        key: this.config.key1,
        value: v,
      });
    },
    change2(v) {
      this.$emit("onChange", {
        key: this.config.key2,
        value: v,
      });
    },
    setViewMode() {
      if (this.viewMode && this.options1 && this.options1.length) {
        // console.log(this.options1)
        this.options1.map(v => {
          if (v.value == this.value1) {
            // console.log(v.label)
            this.value1 = v.label
          }
        })
      }
      if (this.viewMode && this.options2 && this.options2.length) {
        // console.log(this.options2)
        this.options2.map(v => {
          if (v.value == this.value2) {
            // console.log(v.label)
            this.value2 = v.label
          }
        })
      }
    },
  },
  updated() {
    // console.log(
    //   `update '${this.label}' from '${this.value1}' to '${this.inputValue}'`
    // );
    // this.setViewMode()
  },
};
</script>

<style lang="less" scoped>
.el-form-item {
  &.remind {
    .content {
      display: flex;

      .left {
        margin-right: 30px;

        /deep/ .el-select {
          margin: 0 11px;

          // width: 114px;
          .el-input {
            width: 114px;
          }
        }
      }
    }
  }

  &.view {
    /deep/ .el-form-item__label {
      width: 192px !important;
    }
  }
}
</style>
